import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as CryptoJS from 'crypto-js';
import { environment } from 'environments/environment';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subscription } from 'rxjs';
import { CodigoModulos } from '../consts/modulos';
import {
  AbstractError,
  AbstractResponse,
  IColumnsFieldsProps,
  IResponseFieldsProps,
  ISearchFieldsProps,
} from './../interfaces/shared.interface';
import { AuthService } from './api/auth.service';
@Injectable({
  providedIn: 'root',
})
export class AbstractService {
  public entidade: string;
  private urlServer: {};
  public timerId: any;
  public documentos: any;
  tokenFromUI: string = '0123456789123456';
  encrypted: string = '';

  constructor(
    entidade = '',
    public http: HttpClient,
    public authService: AuthService,
    public notification: NzNotificationService,
    public helper = new JwtHelperService()
  ) {
    this.entidade = entidade;

    this.urlServer = {
      [`atestador`]: this.generateUrlByEnvironment(
        '5017',
        'atestador',
        'digitalizacao'
      ),
      [`fileExport`]: this.generateUrlByEnvironment(
        '5017',
        'exportacao/exportar/',
        'digitalizacao'
      ),
      // [`editFileExport`]:this.generateUrlByEnvironment(
      //   '5017',
      //   'exporta'
      // ),
      [`pendingDocument`]: this.generateUrlByEnvironment(
        '5017',
        'document/pending',
        'digitalizacao'
      ),
      [`finishedDocument`]: this.generateUrlByEnvironment(
        '5017',
        'document/finished',
        'digitalizacao'
      ),
      [`document`]: this.generateUrlByEnvironment(
        '5017',
        'document',
        'digitalizacao'
      ),
      [`documentoAnexo`]: this.generateUrlByEnvironment(
        '5017',
        'documento-anexo',
        'digitalizacao'
      ),
      [`documentConcentrator`]: this.generateUrlByEnvironment(
        '5017',
        'document/concentrador',
        'digitalizacao'
      ),
      [`anyDocument`]: this.generateUrlByEnvironment(
        '5017',
        'document/any',
        'digitalizacao'
      ),
      [`assinante`]: this.generateUrlByEnvironment(
        '5017',
        'assinante',
        'digitalizacao'
      ),
      [`certificado`]: this.generateUrlByEnvironment(
        '5017',
        'certificado',
        'digitalizacao'
      ),
      [`tipoDoc`]: this.generateUrlByEnvironment(
        '5017',
        'tipo-documento',
        'digitalizacao'
      ),
      [`pessoaFisica`]: this.generateUrlByEnvironment(
        '5017',
        'pessoa-fisica',
        'digitalizacao'
      ),
      [`senha`]: this.generateUrlByEnvironment('5010', 'senha', 'autorizacao'),
      [`avatar`]: this.generateUrlByEnvironment(
        '5010',
        'usuario/alterar-avatar',
        'autorizacao'
      ),
      [`uploadAvatar`]: this.generateUrlByEnvironment(
        '5017',
        'pessoa-fisica/avatar',
        'digitalizacao'
      ),
      [`deleteAnexo`]: this.generateUrlByEnvironment(
        '5017',
        'documento-anexo/delete',
        'digitalizacao'
      ),
      [`deleteSignatario`]: this.generateUrlByEnvironment(
        '5017',
        'signatario/delete',
        'digitalizacao'
      ),
      [`signatario`]: this.generateUrlByEnvironment(
        '5017',
        'signatario',
        'digitalizacao'
      ),
      [`pessoaContato`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-contato',
        'digitalizacao'
      ),
      [`pessoaFisicaGlobal`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-fisica',
        'digitalizacao'
      ),
      [`pessoaFisicaByCpf`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-fisica/consultar-por-parametro?field=cpf&value=',
        'digitalizacao'
      ),
      [`pessoaFisicaById`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-fisica/consultar-por-parametro?field=id&value=',
        'digitalizacao'
      ),
      [`pessoaById`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-fisica/consultar-por-parametro?field=idPessoa&value=',
        'digitalizacao'
      ),
      [`pessoa-fisica-id-pessoa`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-fisica/consultar-por-parametro',
        'digitalizacao'
      ),
      [`pessoaJuridicaById`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-juridica/consultar-por-parametro?field=id&value=',
        'digitalizacao'
      ),
      [`pessoaJuridica`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-juridica',
        'digitalizacao'
      ),
      [`pessoaJuridicaByCnpj`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-juridica/consultar-por-parametro?field=cnpj&value=',
        'digitalizacao'
      ),
      [`pessoaResponsavelById`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-responsaveis/consultar-por-parametro?field=id&value=',
        'digitalizacao'
      ),
      [`pessoaResponsavelDelete`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-responsaveis',
        'digitalizacao'
      ),
      [`pessoaJuridicaGlobal`]: this.generateUrlByEnvironment(
        '5008',
        'pessoa-juridica',
        'digitalizacao'
      ),
      [`logradouro`]: this.generateUrlByEnvironment(
        '5003',
        'logradouro',
        'endereco'
      ),
      [`unidadeOrc`]: this.generateUrlByEnvironment(
        '80',
        'unidade-orcamentaria/consultar-por-parametro?field=id&value=',
        'unidade-orcamentaria'
      ),
      [`exportador-digitalizacao`]: this.generateUrlByEnvironment(
        '3030',
        'exportador-digitalizacao',
        'digitalizacao'
      ),
      [`exportacao`]: this.generateUrlByEnvironment(
        '3030',
        'exportacao',
        'digitalizacao'
      ),
      [`analitcs`]: this.generateUrlByEnvironment(
        '5017',
        'analitcs',
        'digitalizacao'
      ),
      [`mensagem`]: this.generateUrlByEnvironment(
        '5017',
        'mensagem',
        'digitalizacao'
      ),
      [`mensagem-envio`]: this.generateUrlByEnvironment(
        '5017',
        'mensagem-envio',
        'digitalizacao'
      ),
      [`setor`]: this.generateUrlByEnvironment(
        '5017',
        'setor',
        'digitalizacao'
      ),
      [`modulo-sistema`]: this.generateUrlByEnvironment(
        '5017',
        'modulo',
        'autorizacao'
      ),
      [`modulo`]: this.generateUrlByEnvironment(
        '5017',
        'modulo',
        'digitalizacao'
      ),
      [`submodulo`]: this.generateUrlByEnvironment(
        '5017',
        'submodulo',
        'digitalizacao'
      ),
      [`tipoDocumento`]: this.generateUrlByEnvironment(
        '5017',
        'tipo-documento',
        'digitalizacao'
      ),
      [`pessoa`]: this.generateUrlByEnvironment(
        '3333',
        'arrecadacao-tools/pessoa',
        'arrecadacao-tool'
      ),
      [`alvara`]: this.generateUrlByEnvironment(
        '3333',
        'arrecadacao-tools/alvara',
        'arrecadacao-tool'
      ),
      [`file`]: this.generateUrlByEnvironment(
        '3333',
        'arrecadacao-tools/file',
        'arrecadacao-tool'
      ),
      [`acordo-divida`]: this.generateUrlByEnvironment(
        '3333',
        'arrecadacao-tools/divida',
        'arrecadacao-tool'
      ),
      [`imovel`]: this.generateUrlByEnvironment(
        '3333',
        'arrecadacao-tools/imovel',
        'arrecadacao-tool'
      ),
      [`processo`]: this.generateUrlByEnvironment(
        '3005',
        'processo',
        'processo'
      ),
      //urls-siafic
    };
    // this.getDocumentFromConcentrator()
  }

  generateUrlByEnvironment(port: string, path?: string, server = ''): string {
    // if (['digitalizacao'].includes(server)) {
    //   return `http://localhost:3334/api/${path}`;
    // }

    // if (['auth'].includes(server)) {
    //   return `http://localhost:3004/${path}`;
    // }

    // if (['autorizacao'].includes(server)) {
    //   return `http://localhost:3002/${path}`;
    // }
    // if (server === 'tipo-documento') {
    //   return `http://localhost:3334/${path}`;
    // }

    // if (server === 'assinatura-documentos') {
    //   return `http://localhost:3000/${path}`;
    // }

    // if (server === 'digitalizacao-worker') {
    //   return `http://localhost:3005/${path}`;
    // }

    // if (server === 'exportador') {
    //   return `http://localhost:3030/${path}`;
    // }

    if (['digitalizacao', 'digitalizacao-worker'].includes(server)) {
      return `${environment.apiUrl(server)}/api/${path}`;
    }

    if (
      server === 'upload' ||
      server === 'concentrador' ||
      server === 'autorizacao'
    ) {
      return `${environment.apiOld(server)}/${path}`;
    }

    if (['exportador-digitalizacao', 'exportador'].includes(server)) {
      return `${environment.apiTools(server)}/${path}`;
    }

    return `https://ps-${server}-api.${
      environment.production ? 'prod' : 'dev'
    }.publicservice.com.br/${path}`;
  }

  getUrlAppAcesso(): string {
    return `${environment.appUrl('acesso')}`;
  }

  getUrlAppAssinatura(): string {
    return `${environment.appUrl('assinatura')}`;
  }

  getUrlAppDigitalizacao(): string {
    return `${environment.appUrl('digitalizacao')}`;
  }

  getServer(entidade: string = null): string {
    const entity = entidade ? entidade : this.entidade;
    return `${this.urlServer[entity]}`;
  }

  public headerAuthenticateOptions() {
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'request-date': this.authService.getDateSelected(),
      }),
    };
  }

  isUserAdm() {
    return this.authService.getSubmodulos().some((submodulo) => submodulo.adm);
  }

  async getLoginToken() {
    return await this.http
      .get(
        `${this.getServer('analitcs')}/getLoginToken`,
        this.headerAuthenticateOptions()
      )
      .toPromise()
      .then((result: any) => {
        return result;
      });
  }

  insert(
    object,
    entidade: string = null,
    query = ''
  ): Promise<AbstractResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${this.getServer(entidade)}${query}`,
          object,
          this.headerAuthenticateOptions()
        )
        .toPromise()
        .then((response: any) => {
          this.notification.success(
            entidade === 'documentConcentrator'
              ? 'Integração de documentos'
              : 'Cadastrar',
            response.message
          );
          resolve(response as any);
        })
        .catch((returnError) => {
          // tslint:disable-next-line: no-bitwise
          this.notification.error('Cadastrar', returnError);
        });
    });
  }

  update(
    object: {},
    id: string,
    entidade: string = null,
    query = ''
  ): Promise<AbstractResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .put(
          `${this.getServer(entidade)}/${id}${query}`,
          object,
          this.headerAuthenticateOptions()
        )
        .toPromise()
        .then((response: AbstractResponse) => {
          this.notification.success('Alterar', response.message);
          resolve(response as AbstractResponse);
        })
        .catch((returnError: any) => {
          this.notification.error('Alterar', returnError);
          reject({
            message: returnError,
            data: undefined,
          } as AbstractResponse);
        });
    });
  }

  public consultarPessoaFisicaPorParametro(param: {
    [key: string]: string | number | boolean;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      const ob$: Subscription = this.http
        .get(
          `${this.getServer('pessoa-fisica-id-pessoa')}?${this.buildQueryParams(
            param
          )}`,
          this.headerAuthenticateOptions()
        )
        .subscribe({
          next: (resp) => resolve(resp),
          error: (e) => reject(e),
          complete: () => {
            ob$.unsubscribe();
          },
        });
    });
  }

  pesquisar(parametrosPesquisa, entidade = null) {
    if (
      !parametrosPesquisa.value &&
      parametrosPesquisa.field.valor !== 'todos'
    ) {
      this.notification.warning('Atenção', 'Insira um valor para pesquisa.');
      return;
    }

    return this.pesquisarAvancado(parametrosPesquisa, entidade);
  }

  pesquisarAvancado(parametros, entidade = null): Promise<AbstractResponse> {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          `${this.getServer(entidade)}/global-search?page=${
            parametros.page
          }&size=${parametros.size}&${parametros.field.valor}=${
            parametros.value
          }`,
          this.headerAuthenticateOptions()
        )
        .toPromise()
        .then((response: any) => {
          response.data.resultado.length === 0
            ? this.notification.info('Pesquisa', 'Nenhum registro encontrado.')
            : this.notification.success('Pesquisa', response.message);

          resolve(response as { message: string; data: any });
        })
        .catch((returnError) => {
          reject({
            message: returnError,
            data: undefined,
          } as AbstractResponse);
        });
    });
  }

  globalSearch(
    value: string,
    all = false,
    entidade: string = null
  ): Promise<{ message: string; data: any }> {
    return new Promise((resolve, reject) => {
      if (!value && !all) {
        this.notification.warning('Atenção', 'Insira um valor para pesquisa.');
        reject({ message: undefined, data: undefined } as AbstractResponse);
      }

      const paramAll = all ? `&all=${all}` : '';
      this.http
        .get(
          `${this.getServer(entidade)}?value=${value}${paramAll}`,
          this.headerAuthenticateOptions()
        )
        .toPromise()
        .then((response: { message: string; data: any }) => {
          // response.data.length === 0
          //   ? this.notification.info('Pesquisa', 'Nenhum registro encontrado.')
          //   : this.notification.success('Pesquisa', response.message);

          resolve(response as { message: string; data: any });
        })
        .catch((err: AbstractError) => {
          this.notification.error('Pesquisa', `${err}`);
          reject({ message: err.error.message, data: undefined } as {
            message: string;
            data: any;
          });
        });
    });
  }

  getByIdPublico(
    value: string,
    entidade: string = null
  ): Promise<{ message: string; data: any }> {
    return new Promise((resolve, reject) => {
      if (!value) {
        this.notification.warning('Atenção', 'Insira um valor para pesquisa.');
        reject({ message: undefined, data: undefined } as AbstractResponse);
      }

      this.http
        .get(
          `${this.getServer(entidade)}/id-publico/${value}`,
          this.headerAuthenticateOptions()
        )
        .toPromise()
        .then((response: { message: string; data: any }) => {
          response.data.length === 0
            ? this.notification.info('Pesquisa', 'Nenhum registro encontrado.')
            : '';

          resolve(response as { message: string; data: any });
        })
        .catch((err: AbstractError) => {
          this.notification.error('Pesquisa', `${err}`);
          reject({ message: err.error.message, data: undefined } as {
            message: string;
            data: any;
          });
        });
    });
  }

  async getDocumentTableProps(
    entidade: string = null
  ): Promise<IResponseFieldsProps> {
    const camposPesquisa: ISearchFieldsProps[] = [];
    const colunasTabela: IColumnsFieldsProps[] = [];
    return await this.http
      .get(
        `${this.getServer(entidade)}/props`,
        this.headerAuthenticateOptions()
      )
      .toPromise()
      .then((response: { message: string; data: any }) => {
        camposPesquisa.push({
          text: 'Todos',
          value: 'todos',
        });

        for (const p in response.data) {
          if (response.data[p].isSearch) {
            camposPesquisa.push({
              text: response.data[p].label,
              value: p,
            });
          }
        }
        for (const p in response.data) {
          if (response.data[p].columnTable) {
            colunasTabela.push({
              text: response.data[p].label,
              value: p,
              mask: response.data[p].mask ? response.data[p].mask : null,
              objectChildren: response.data[p].hasOwnProperty('objectChildren')
                ? response.data[p].objectChildren[0]
                : null,
              type: response.data[p].type,
            });
          }
        }
        return { searchColumns: camposPesquisa, tableColumns: colunasTabela };
      })
      .catch((err: AbstractError) => {
        this.notification.error('Propriedades', err.error.message);
        return { searchColumns: camposPesquisa, tableColumns: colunasTabela };
      });
  }

  getPropsEventTableDocMock() {
    return new Promise((resolve) =>
      resolve({
        message: 'Consulta Realizada',
        data: {
          data: {
            isSearch: true,
            label: 'Data',
            columnTable: true,
            mask: 'full-date',
          },
          acao: {
            isSearch: true,
            label: 'Ação',
            columnTable: true,
          },
          usuario: {
            isSearch: true,
            label: 'Usuário',
            columnTable: true,
          },
        },
      })
    );
  }

  getUserInfoPermissions(infoToken) {
    return this.http
      .get(
        `${this.generateUrlByEnvironment(
          '5010',
          'api',
          'autorizacao'
        )}/usuario/${
          infoToken.userInfo.idUg
        }/consultar-por-parametro?field=id&value=${
          infoToken.userInfo.idUsuario
        }`,
        this.headerAuthenticateOptions()
      )
      .toPromise()
      .then((resultUser: any) => {
        const usuario = resultUser.data;
        return this.http
          .get(
            `${this.generateUrlByEnvironment(
              '5008',
              'pessoa-fisica',
              'digitalizacao'
            )}/consultar-por-parametro?field=id&value=${
              usuario.idPessoaFisica
            }`,
            this.headerAuthenticateOptions()
          )
          .toPromise()
          .then((resultPessoa: any) => {
            const pessoaFisica = resultPessoa.data;
            return { usuario, pessoaFisica };
          });
      });
  }

  async isAdmUser(): Promise<boolean> {
    const infoToken = this.helper.decodeToken(this.authService.getToken());

    const userInfo = await this.getUserInfoPermissions(infoToken);

    return userInfo.usuario.vinculacoes.some(
      (vinculacao) =>
        (vinculacao.perfil.adm === 1 &&
          vinculacao.perfil.idUnidadeGestora === infoToken.userInfo.idUg) ||
        vinculacao.perfil.perMod.some(
          (perfMod) =>
            perfMod.modulo.codigo === CodigoModulos[3] &&
            perfMod.modulo.codigo === 1
        )
    );
  }

  encryptUsingAES256(value: string) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    this.encrypted = encrypted.toString();
    return this.encrypted;
  }

  private buildQueryParams(params: {
    [key: string]: string | number | boolean;
  }): string {
    const arrQuery: string[] = new Array();
    for (const key in params) {
      if (params[key]) {
        arrQuery.push(`${key}=${params[key]}`);
      }
    }

    return arrQuery.join('&');
  }
}
